<template lang="pug">
.day-tabs-host
  .day-tabs(v-if="dayFilters.length" :class="{ 'day-tabs--stacked': !stripFitsBesideActions, 'day-tabs--teleported': isTeleported }" ref="dayTabs")
    .day-tabs__actions
      button.day-tabs__action.day-tabs__action--my-schedule(type="button" @click="$emit('open-modal', 'my-schedule-button')") My Schedule
      .day-tabs__print(ref="printRoot")
        button.day-tabs__print-trigger.day-tabs__action.day-tabs__action--icon-btn(
          type="button"
          @click="togglePrintMenu"
          aria-haspopup="true"
          :aria-expanded="printMenuOpen ? 'true' : 'false'"
          aria-label="Print schedule")
          svg(viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true")
            path(
              d="M14.47 12.04H12.45C12.17 12.04 11.9 11.83 11.9 11.48C11.9 11.13 12.1 10.92 12.45 10.92H14.47C14.61 10.92 14.75 10.92 14.82 10.78C14.89 10.64 14.96 10.57 14.96 10.43V5.43C14.96 5.29 14.96 5.15 14.82 5.08C14.68 5.01 14.61 4.94 14.47 4.94H1.53C1.39 4.94 1.25 4.94 1.18 5.08C1.11 5.22 1.04 5.29 1.04 5.43V10.43C1.04 10.57 1.04 10.71 1.18 10.78C1.32 10.85 1.39 10.92 1.53 10.92H3.55C3.83 10.92 4.10 11.13 4.10 11.48C4.10 11.83 3.90 12.04 3.55 12.04H1.53C1.11 12.04 0.77 11.90 0.49 11.62C0.21 11.34 0 10.92 0 10.50V5.50C0 5.08 0.14 4.73 0.42 4.45C0.70 4.17 1.11 4.03 1.46 4.03H14.47C14.89 4.03 15.23 4.17 15.51 4.45C15.79 4.73 15.93 5.15 15.93 5.50V10.50C15.93 10.92 15.79 11.27 15.51 11.55C15.23 11.83 14.82 11.97 14.47 11.97V12.04Z"
              fill="currentColor")
            path(
              d="M3.48 7.03H2.50C2.23 7.03 1.95 6.82 1.95 6.47C1.95 6.12 2.16 5.91 2.50 5.91H3.48C3.76 5.91 4.04 6.12 4.04 6.47C4.04 6.82 3.83 7.03 3.48 7.03Z"
              fill="currentColor")
            path(
              d="M12.52 16H3.48C3.20 16 2.92 15.79 2.92 15.44V8.42C2.92 8.14 3.13 7.86 3.48 7.86H12.45C12.73 7.86 13.01 8.07 13.01 8.42V15.44C13.01 15.72 12.80 16 12.45 16H12.52ZM4.03 14.96H11.97V8.97H4.03V14.96Z"
              fill="currentColor")
            path(
              d="M12.52 5.01H3.48C3.20 5.01 2.92 4.80 2.92 4.45V1.53C2.92 1.11 3.06 0.77 3.34 0.49C3.62 0.21 4.10 0 4.52 0H11.55C11.97 0 12.31 0.14 12.59 0.42C12.87 0.70 13.01 1.11 13.01 1.46V4.45C13.01 4.73 12.80 5.01 12.45 5.01L12.52 5.01ZM4.03 3.97H11.97V1.46C11.97 1.32 11.97 1.18 11.83 1.11C11.69 1.04 11.62 0.97 11.48 0.97H4.52C4.38 0.97 4.24 0.97 4.17 1.11C4.10 1.25 4.03 1.32 4.03 1.46V3.97Z"
              fill="currentColor")
            path(
              d="M10.50 10.99H5.50C5.22 10.99 4.94 10.78 4.94 10.44C4.94 10.09 5.15 9.88 5.50 9.88H10.50C10.78 9.88 11.06 10.09 11.06 10.44C11.06 10.78 10.85 10.99 10.50 10.99Z"
              fill="currentColor")
            path(
              d="M8.97 13.01H5.50C5.22 13.01 4.94 12.80 4.94 12.45C4.94 12.10 5.15 11.90 5.50 11.90H8.97C9.25 11.90 9.53 12.10 9.53 12.45C9.53 12.80 9.32 13.01 8.97 13.01Z"
              fill="currentColor")
        ul.day-tabs__print-menu(v-show="printMenuOpen" role="menu")
          li(role="none")
            button.day-tabs__print-menu-item(type="button" role="menuitem" @click="onPrint('all')") Print Full Schedule
          li(role="none")
            button.day-tabs__print-menu-item(type="button" role="menuitem" @click="onPrint('current')") Print Current Search Results
      button.day-tabs__action.day-tabs__action--icon-btn(type="button" ref="shareBtn" @click="$emit('open-share', { triggerEl: $refs.shareBtn })" aria-label="Share schedule")
        svg(viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true")
          path(
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.93 2.67C9.93 2.04 10.16 1.44 10.57 0.96C10.99 0.48 11.57 0.16 12.21 0.04C12.85 -0.07 13.51 0.04 14.08 0.34C14.64 0.65 15.08 1.13 15.32 1.71C15.55 2.29 15.56 2.94 15.35 3.53C15.14 4.11 14.72 4.62 14.17 4.94C13.61 5.27 12.96 5.40 12.31 5.31C11.67 5.22 11.08 4.91 10.64 4.45L8.31 5.67L5.71 7.09C6.07 7.70 6.17 8.43 5.97 9.11L10.64 11.55C11.10 11.06 11.73 10.76 12.41 10.68C13.08 10.61 13.77 10.78 14.32 11.16C14.88 11.54 15.27 12.10 15.43 12.73C15.58 13.37 15.49 14.04 15.16 14.61C14.83 15.19 14.29 15.62 13.65 15.84C13.01 16.06 12.30 16.05 11.67 15.81C11.04 15.56 10.52 15.10 10.22 14.52C9.91 13.93 9.85 13.26 10.03 12.63L5.36 10.19C5.00 10.57 4.54 10.84 4.03 10.98C3.51 11.12 2.97 11.11 2.46 10.96C1.95 10.81 1.50 10.52 1.16 10.13C0.81 9.74 0.59 9.27 0.52 8.76C0.45 8.26 0.54 7.74 0.76 7.28C0.99 6.82 1.34 6.43 1.79 6.16C2.24 5.88 2.77 5.74 3.30 5.74C3.83 5.75 4.35 5.89 4.80 6.17L7.69 4.59L10.03 3.37C9.96 3.14 9.93 2.90 9.93 2.67ZM12.71 1.23C12.32 1.23 11.93 1.38 11.65 1.65C11.37 1.92 11.21 2.29 11.21 2.67C11.21 3.05 11.37 3.41 11.65 3.68C11.93 3.95 12.32 4.10 12.71 4.10C13.11 4.10 13.49 3.95 13.77 3.68C14.06 3.41 14.21 3.05 14.21 2.67C14.21 2.29 14.06 1.92 13.77 1.65C13.49 1.38 13.11 1.23 12.71 1.23ZM3.29 6.97C2.89 6.97 2.51 7.13 2.22 7.39C1.94 7.66 1.79 8.03 1.79 8.41C1.79 8.79 1.94 9.16 2.22 9.42C2.51 9.69 2.89 9.85 3.29 9.85C3.68 9.85 4.07 9.69 4.35 9.42C4.63 9.16 4.79 8.79 4.79 8.41C4.79 8.03 4.63 7.66 4.35 7.39C4.07 7.13 3.68 6.97 3.29 6.97ZM11.21 13.33C11.21 12.95 11.37 12.59 11.65 12.32C11.93 12.05 12.32 11.90 12.71 11.90C13.11 11.90 13.49 12.05 13.77 12.32C14.06 12.59 14.21 12.95 14.21 13.33C14.21 13.71 14.06 14.08 13.77 14.35C13.49 14.62 13.11 14.77 12.71 14.77C12.32 14.77 11.93 14.62 11.65 14.35C11.37 14.08 11.21 13.71 11.21 13.33Z"
            fill="currentColor")
    .day-tabs__strip(:class="{ 'day-tabs__strip--initial': !hasMeasured }" ref="dayTabsStrip")
      button.day-tab.day-tab--all-days(
        :class="{ 'day-tab--active': !selectedDayValue }"
        @click="selectAllDays"
        type="button"
        :aria-pressed="String(!selectedDayValue)") All Days
      button.day-tab.day-tab--day(
        v-for="day in dayFilters"
        :key="day.id"
        :class="{ 'day-tab--active': day.selected }"
        @click="selectDay(day)"
        ref="dayTabEls"
        :aria-pressed="String(day.selected)") {{ dayLabelFormatter(day.value) }}
</template>

<script>
import { mapGetters } from 'vuex';
import { formatDayLabel, formatDayLabelShort } from './scheduleResultGrouping.js';

export default {
  name: 'DayTabs',

  data() {
    return {
      printMenuOpen: false,
      isTeleported: false,
      stripFitsBesideActions: true,
      hasMeasured: false,
      forceShortLabels: false,
      measuring: false,
    };
  },

  computed: {
    ...mapGetters(['allDays', 'selectedDayValue']),

    dayFilters() {
      return this.allDays.map(d => ({
        ...d,
        selected: d.value === this.selectedDayValue,
      }));
    },

    dayLabelMode() {
      // Short labels when count rule says so (≥5) OR when measurement forced short
      // because the long labels didn't fit beside the actions.
      return (this.forceShortLabels || this.dayFilters.length >= 5) ? 'short' : 'full';
    },

    dayLabelFormatter() {
      return this.dayLabelMode === 'full' ? formatDayLabel : formatDayLabelShort;
    },
  },

  watch: {
    dayFilters() {
      this.queueMeasure();
    },
  },

  mounted() {
    document.addEventListener('mousedown', this.onOutsideClick);
    document.addEventListener('keydown', this.onPrintKeydown);
    // Drive measurement off of window resize (an external signal) instead of a
    // strip ResizeObserver. The strip's size also changes due to our own DOM
    // mutations during a measurement (label switches, --stacked toggle), and
    // listening for those creates a feedback loop on top of the multi-await
    // measurement cycle.
    this.onWindowResizeForMeasure = this.onWindowResizeForMeasure.bind(this);
    window.addEventListener('resize', this.onWindowResizeForMeasure);
    this.$nextTick(() => {
      this.setupTeleport();
      this.queueMeasure();
    });
  },

  beforeDestroy() {
    document.removeEventListener('mousedown', this.onOutsideClick);
    document.removeEventListener('keydown', this.onPrintKeydown);
    window.removeEventListener('resize', this.onWindowResizeForMeasure);
    if (this.measureRAF) {
      cancelAnimationFrame(this.measureRAF);
      this.measureRAF = null;
    }
    this.teardownTeleport();
  },

  methods: {
    formatDayLabel,

    selectDay(day) {
      if (day.value === this.selectedDayValue) return;
      this.$store.commit('setSelectedDay', day.value);
      this.$store.commit('setPageIndex', 0);
      this.$store.dispatch('executeSearch');
    },

    selectAllDays() {
      if (!this.selectedDayValue) return;
      this.$store.commit('setSelectedDay', null);
      this.$store.commit('setPageIndex', 0);
      this.$store.dispatch('executeSearch');
    },

    togglePrintMenu() {
      this.printMenuOpen = !this.printMenuOpen;
    },

    onPrint(scope) {
      this.printMenuOpen = false;
      this.$emit('print', scope);
    },

    onOutsideClick(event) {
      if (!this.printMenuOpen) return;
      const root = this.$refs.printRoot;
      if (root && !root.contains(event.target)) {
        this.printMenuOpen = false;
      }
    },

    onPrintKeydown(event) {
      if (event.key === 'Escape' && this.printMenuOpen) {
        this.printMenuOpen = false;
      }
    },

    async measureDayTabs() {
      if (this.measuring) return;
      const strip = this.$refs.dayTabsStrip;
      const tabs = (this.$refs.dayTabEls || []).filter(Boolean);
      if (!strip || tabs.length === 0) return;

      this.measuring = true;
      try {
        await this.runMeasurementPass(strip);
      } finally {
        this.measuring = false;
      }
    },

    onWindowResizeForMeasure() {
      // Coalesce rapid resize events into one measurement per animation frame.
      if (this.measureRAF) return;
      this.measureRAF = requestAnimationFrame(() => {
        this.measureRAF = null;
        this.measureDayTabs();
      });
    },

    async runMeasurementPass(strip) {
      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

      const tabs = (this.$refs.dayTabEls || []).filter(Boolean);
      if (tabs.length === 0) return;

      // On mobile, the SCSS .day-tab { min-width: 100px } floor governs sizing
      // and the strip uses its own scroll-with-fade pattern. Clear any inline
      // min-width and any forceShortLabels state from a previous desktop pass.
      if (!isDesktop) {
        tabs.forEach(t => { t.style.minWidth = ''; });
        this.forceShortLabels = false;
        this.hasMeasured = true;
        return;
      }

      const previousVisibility = strip.style.visibility;
      strip.style.visibility = 'hidden';

      // Always begin a measurement cycle with count-based default labels so we
      // can re-evaluate label format from scratch each time.
      if (this.forceShortLabels) {
        this.forceShortLabels = false;
        await this.$nextTick();
      }

      const measureAndCheckFit = () => {
        const liveTabs = (this.$refs.dayTabEls || []).filter(Boolean);
        liveTabs.forEach(t => { t.style.minWidth = ''; });

        let max = 0;
        liveTabs.forEach(t => {
          const w = t.getBoundingClientRect().width;
          if (w > max) max = w;
        });

        const tabMinWidth = Math.ceil(max);
        liveTabs.forEach(t => { t.style.minWidth = `${tabMinWidth}px`; });

        const dayTabsRoot = this.$refs.dayTabs;
        const allDaysEl = strip.querySelector('.day-tab--all-days');
        const actionsEl = dayTabsRoot ? dayTabsRoot.querySelector('.day-tabs__actions') : null;
        if (!dayTabsRoot || !actionsEl) return true;

        // Actions' natural width = sum of children widths + inter-child gaps.
        // This is independent of whether actions is currently stretched (in
        // the stacked layout) or naturally sized (side-by-side), so the fit
        // decision is stable across re-measures from any starting layout.
        const actionsChildren = Array.from(actionsEl.children);
        let actionsWidth = 0;
        actionsChildren.forEach(c => {
          actionsWidth += c.getBoundingClientRect().width;
        });
        const actionsGap = 12; // matches .day-tabs__actions { gap: 12px }
        if (actionsChildren.length > 1) {
          actionsWidth += (actionsChildren.length - 1) * actionsGap;
        }

        const allDaysWidth = allDaysEl ? allDaysEl.getBoundingClientRect().width : 0;
        const stripGap = 16; // matches .day-tabs__strip { gap: 16px }
        const rootGap = 12;  // matches .day-tabs desktop { gap: 12px }
        const stripNeededWidth = allDaysWidth + liveTabs.length * tabMinWidth + liveTabs.length * stripGap;
        const availableWidth = dayTabsRoot.clientWidth - actionsWidth - rootGap;
        return stripNeededWidth <= availableWidth;
      };

      let fits = measureAndCheckFit();

      // If default labels don't fit AND we have ≤4 days (currently long),
      // try shortening the labels.
      if (!fits && this.dayFilters.length <= 4) {
        this.forceShortLabels = true;
        await this.$nextTick();
        fits = measureAndCheckFit();

        if (!fits) {
          // Short labels also don't fit — we're going to stack. Stacked mode
          // uses count-based default labels (≤4 long, ≥5 short), so revert
          // forceShortLabels and re-measure tab widths for the long labels.
          this.forceShortLabels = false;
          await this.$nextTick();
          measureAndCheckFit();
        }
      }

      this.stripFitsBesideActions = fits;
      this.hasMeasured = true;

      // Wait for Vue to apply the --stacked class binding (and any final
      // label-mode change) before restoring visibility and re-evaluating
      // sticky/teleport state against the new layout.
      await this.$nextTick();
      strip.style.visibility = previousVisibility || '';
      this.updateTeleportState();
    },

    queueMeasure() {
      this.$nextTick(() => this.measureDayTabs());
    },

    setupTeleport() {
      const dayTabsEl = this.$refs.dayTabs;
      if (!dayTabsEl) return;

      // Cache the original parent + next sibling so we can restore on unmount or
      // when scrolling back up.
      this.dayTabsHomeParent = dayTabsEl.parentNode;
      this.dayTabsHomeNextSibling = dayTabsEl.nextSibling;

      // Create a placeholder that will sit in the original location while
      // .day-tabs is teleported, preserving layout flow.
      this.placeholderEl = document.createElement('div');
      this.placeholderEl.className = 'day-tabs__placeholder';
      this.placeholderEl.setAttribute('aria-hidden', 'true');

      // A single scroll/resize handler decides both teleport state and synced
      // left/width, comparing the natural position against the live --sticky-offset.
      // Using IntersectionObserver isn't viable here because the threshold is
      // dynamic (depends on --sticky-offset which changes as the nav hides/shows).
      this.updateTeleportState = this.updateTeleportState.bind(this);
      this.scheduleResizeStabilize = this.scheduleResizeStabilize.bind(this);
      window.addEventListener('resize', this.updateTeleportState);
      // The site nav recomputes --sticky-offset during resize and passes through
      // transient values before settling. updateTeleportState reads --sticky-offset
      // every resize event, so the live values can latch the wrong teleport state.
      // This trailing-edge debounce re-runs once after the resize stream stops,
      // when --sticky-offset has stabilized.
      window.addEventListener('resize', this.scheduleResizeStabilize);
      window.addEventListener('scroll', this.updateTeleportState, { passive: true });

      // Initial check so first paint is correct (e.g. if the user navigates in
      // already scrolled past the natural position).
      this.setupSectionObserver();
      this.updateTeleportState();
    },

    teardownTeleport() {
      this.teardownSectionObserver();
      window.removeEventListener('resize', this.updateTeleportState);
      window.removeEventListener('resize', this.scheduleResizeStabilize);
      window.removeEventListener('scroll', this.updateTeleportState);
      if (this.resizeStabilizeTimer) {
        clearTimeout(this.resizeStabilizeTimer);
        this.resizeStabilizeTimer = null;
      }

      // If currently teleported, restore .day-tabs to its home before unmounting
      // so Vue's vdom can detach it cleanly.
      if (this.isTeleported) {
        this.restoreFromBody();
      }
      this.placeholderEl = null;
      this.dayTabsHomeParent = null;
      this.dayTabsHomeNextSibling = null;
    },

    setupSectionObserver() {
      const section = this.$el.closest('.section-tabs__section');
      if (!section) return;
      this.observedSection = section;
      this.sectionObserver = new MutationObserver(() => {
        const el = this.observedSection;
        if (!el) return;
        if (!el.classList.contains('active')) {
          this.setTeleported(false);
        } else {
          this.updateTeleportState();
        }
      });
      this.sectionObserver.observe(this.observedSection, {
        attributes: true,
        attributeFilter: ['class'],
      });
    },

    teardownSectionObserver() {
      if (!this.sectionObserver) return;
      this.sectionObserver.disconnect();
      this.sectionObserver = null;
      this.observedSection = null;
    },

    scheduleResizeStabilize() {
      if (this.resizeStabilizeTimer) clearTimeout(this.resizeStabilizeTimer);
      this.resizeStabilizeTimer = setTimeout(() => {
        this.resizeStabilizeTimer = null;
        this.updateTeleportState();
      }, 300);
    },

    setTeleported(shouldTeleport) {
      if (shouldTeleport === this.isTeleported) return;
      if (shouldTeleport) {
        this.teleportToBody();
      } else {
        this.restoreFromBody();
      }
      this.isTeleported = shouldTeleport;
    },

    teleportToBody() {
      const dayTabsEl = this.$refs.dayTabs;
      if (!dayTabsEl || !this.placeholderEl || !this.dayTabsHomeParent) return;

      // Capture the current natural height before removing from flow so the
      // placeholder takes the right amount of vertical space.
      const naturalHeight = dayTabsEl.offsetHeight;
      this.placeholderEl.style.height = naturalHeight + 'px';

      // Insert placeholder where .day-tabs was, then move .day-tabs to body.
      this.dayTabsHomeParent.insertBefore(this.placeholderEl, dayTabsEl);
      document.body.appendChild(dayTabsEl);
      // Imperative add for immediate effect — isTeleported flips on the next
      // line and Vue re-renders the class binding on the next microtask, but
      // the class needs to be present before any paint between the move and
      // that microtask. The :class binding (`day-tabs--teleported: isTeleported`)
      // takes over from here so subsequent re-renders triggered by other
      // bindings (e.g. --stacked) don't wipe it via setAttribute('class', ...).
      dayTabsEl.classList.add('day-tabs--teleported');

      // Sync left/width inline (do NOT call updateTeleportState here — it
      // re-evaluates teleport state and recurses while this.isTeleported is
      // still false, breaking the state machine).
      const placeholderRect = this.placeholderEl.getBoundingClientRect();
      dayTabsEl.style.left = placeholderRect.left + 'px';
      dayTabsEl.style.width = placeholderRect.width + 'px';
    },

    restoreFromBody() {
      const dayTabsEl = this.$refs.dayTabs;
      if (!dayTabsEl || !this.placeholderEl || !this.dayTabsHomeParent) return;

      dayTabsEl.classList.remove('day-tabs--teleported');
      dayTabsEl.style.left = '';
      dayTabsEl.style.width = '';

      // Move .day-tabs back to its original spot, then remove placeholder.
      this.dayTabsHomeParent.insertBefore(dayTabsEl, this.placeholderEl);
      if (this.placeholderEl.parentNode) {
        this.placeholderEl.parentNode.removeChild(this.placeholderEl);
      }
    },

    updateTeleportState() {
      const dayTabsEl = this.$refs.dayTabs;
      if (!dayTabsEl) return;

      if (this.observedSection && !this.observedSection.classList.contains('active')) {
        this.setTeleported(false);
        return;
      }

      // Reference element for natural position:
      //   - when teleported: the placeholder (which sits where .day-tabs used to)
      //   - when inline:     .day-tabs itself
      const referenceEl = this.isTeleported ? this.placeholderEl : dayTabsEl;
      if (!referenceEl || !referenceEl.parentNode) return;
      const naturalRect = referenceEl.getBoundingClientRect();

      const stickyOffsetStr = getComputedStyle(document.documentElement)
        .getPropertyValue('--sticky-offset');
      const stickyOffset = parseFloat(stickyOffsetStr) || 0;

      // Teleport when the natural position has scrolled above (or to) the
      // sticky-offset line — that's where .day-tabs would sit when fixed. Restore
      // when the natural position is below the line.
      const shouldTeleport = naturalRect.top <= stickyOffset;
      this.setTeleported(shouldTeleport);

      // Keep the teleported element's left/width matched to the placeholder
      // and the placeholder's height matched to the (potentially-changed)
      // natural height of the day-tabs (e.g., after a stack/unstack switch).
      if (this.isTeleported) {
        this.placeholderEl.style.height = dayTabsEl.offsetHeight + 'px';
        const placeholderRect = this.placeholderEl.getBoundingClientRect();
        dayTabsEl.style.left = placeholderRect.left + 'px';
        dayTabsEl.style.width = placeholderRect.width + 'px';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './tokens';

$lg-min: 1024px;

.day-tabs-host {
  display: contents;
}

// Mobile (< 1024px) default:
//   - .day-tabs is a flex column; actions render ABOVE the strip.
//   - When the user scrolls past the natural position, mounted() teleports
//     the whole .day-tabs to <body> and applies .day-tabs--teleported.
.day-tabs {
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  position: relative;

  // Right-edge fade overlay on the day strip — hints that more days are
  // scrollable. Mobile only; desktop wraps the strip so no fade is needed.
  // The gradient ends in the same color as the page-surround / teleport
  // bleed so it blends in both inline and teleported states.
  &::after {
    content: "";
    position: absolute;
    right: -3px;
    bottom: 12px;
    width: 40px;
    height: 64px;
    background: linear-gradient(to right, rgba(247, 247, 248, 0), rgb(247, 247, 248));
    pointer-events: none;
  }

  &--teleported {
    position: fixed;
    top: var(--sticky-offset, 0px);
    z-index: $sticky-tabs-z;
    margin-bottom: 0;
    // left, width set imperatively in JS to match the placeholder.

    // Background bleed: a wide pseudo-element that spans the viewport
    // horizontally so the teleported strip matches the page-surround color
    // even though .day-tabs itself only spans the centered column width.
    &::before {
      content: "";
      position: absolute;
      left: -2000px;
      right: -2000px;
      top: 0;
      bottom: 0;
      background: rgb(247, 247, 248);
      z-index: -1;
    }

    @media (prefers-reduced-motion: no-preference) {
      transition: top 0.25s ease;
    }
  }
}

@media print {
  // Suppress teleport positioning in print so day-tabs appears inline.
  // (In practice the print pathway snapshots the schedule into
  // SchedulePrintView, so .day-tabs may not appear at all — but this is a
  // defensive reset in case the user prints from the browser chrome.)
  .day-tabs--teleported {
    position: static !important;
    box-shadow: none !important;
    transition: none !important;

    &::before {
      display: none !important;
    }
  }
}

.day-tabs__strip {
  display: flex;
  gap: 16px;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 8px 0 12px;
  // Avoid the active day tab being clipped on the leading edge while scrolling.
  scroll-padding-inline: 4px;
  // Hide the horizontal scrollbar across all browsers; the right-edge fade
  // gradient on `.day-tabs::after` is the affordance for "more days scrollable".
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  // Prevent each day-tab from shrinking when the strip overflows horizontally.
  & > .day-tab {
    flex-shrink: 0;
  }

  & > .day-tab:last-child {
    margin-right: 40px; // Account for the right-edge fade gradient and ensure the last tab is fully visible when scrolled all the way to the end.
  }
}

.day-tabs__strip--initial {
  visibility: hidden;
}

.day-tabs__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
  margin-bottom: 12px;
}

.day-tab {
  background: white;
  min-width: 100px;
  height: 64px;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid $color-border;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: $color-text-secondary;
  font-family: 'Public Sans', sans-serif;
  cursor: pointer;
  box-shadow: $shadow-card;
  transition: all 0.15s ease;
  text-align: center;
  line-height: 1.3;

  &--active {
    background: $color-tab-active-bg;
    border-color: $color-tab-active-bg;
    box-shadow: $shadow-xl;
    font-weight: 700;
    color: $color-cta-text;

    &:focus-visible {
      outline: 2px solid $color-primary;
      outline-offset: 2px;
    }
  }

  &:hover:not(.day-tab--active) {
    background: $color-surface-hover;
    border-color: $color-btn-outline-hover-border;
  }

  &:focus-visible {
    outline: 2px solid $color-primary;
    outline-offset: 2px;
  }
}

.day-tabs__action--my-schedule {
  height: 40px;
  padding: 8px 16px;
  background: $color-cta-accent;
  border-radius: 8px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  color: $color-cta-text;
  font-family: 'Public Sans', sans-serif;
  cursor: pointer;
  box-shadow: $shadow-btn;

  &:hover {
    background: $color-cta-accent-hover;
  }

  &:focus-visible {
    outline: 2px solid $color-primary;
    outline-offset: 2px;
  }
}

.day-tabs__action--icon-btn {
  width: 40px;
  height: 40px;
  padding: 8px;
  background: white;
  border-radius: 8px;
  border: 1px solid $color-border;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: $color-cta-text;

  &:hover {
    background: $color-surface-hover;
    border-color: $color-btn-outline-hover-border;
  }

  &:focus-visible {
    outline: 2px solid $color-primary;
    outline-offset: 2px;
  }
}

.day-tabs__print {
  position: relative;
  display: inline-block;
}

.day-tabs__print-trigger {
  // Inherits .day-tabs__action--icon-btn styling — just ensure it stays as the
  // dropdown anchor.
}

.day-tabs__print-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 240px;
  margin: 0;
  padding: 4px 0;
  list-style: none;
  background: white;
  border: 1px solid $color-border;
  border-radius: 8px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 20;

  li {
    margin: 0;
    padding: 0;
  }
}

.day-tabs__print-menu-item {
  display: block;
  width: 100%;
  padding: 10px 16px;
  background: transparent;
  border: 0;
  text-align: left;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: $color-text-dark;
  cursor: pointer;
  white-space: nowrap;

  &:hover,
  &:focus {
    background: $color-surface-sunken;
    outline: none;
  }
}

.day-tabs-host::v-deep .day-tabs__placeholder {
  // Set inline by JS to match .day-tabs height when teleported. Keep visibility
  // hidden so it doesn't show borders/backgrounds, but still occupies space.
  visibility: hidden;
  pointer-events: none;
  margin-bottom: 24px;
}

// Desktop (>= 1024px): use flexbox `order` to put the strip first (left) and
// actions second (right), while preserving DOM order for mobile.
@media (min-width: $lg-min) {
  .day-tabs {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 0;

    &::after { display: none; }
  }

  // When measurement determines the strip can't fit beside the actions, stack
  // them: actions on top, strip below — matching the mobile pattern. The strip
  // then takes the full row and scrolls horizontally with the right-edge fade.
  .day-tabs--stacked {
    flex-direction: column;
    align-items: stretch;

    &::after { display: block; }

    .day-tabs__actions {
      order: 1;
      justify-content: flex-end;
    }

    .day-tabs__strip {
      order: 2;
      flex-wrap: nowrap;
      overflow-x: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar { display: none; }

      & > .day-tab:last-child {
        margin-right: 40px; // Account for the right-edge fade gradient and ensure the last tab is fully visible when scrolled all the way to the end.
      }
    }
  }

  .day-tabs__strip {
    order: 1;
    flex: 1;
    flex-wrap: wrap;
    overflow-x: visible;
    padding: 0;
    background: transparent;

    & > .day-tab:last-child {
      margin-right: 0;
    }
  }

  .day-tabs__actions {
    order: 2;
    justify-content: flex-start;
    margin-top: 0;
    margin-bottom: 0;
    flex-shrink: 0;
  }
}
</style>
